import PropTypes from 'prop-types';
import React from 'react';

import Icon from './Icon';

const ToggleSwitch = ({
	isInvalid = false,
	isValid = false,
	name = '',
	offLabel = '',
	onBlur = null,
	onChange = null,
	onLabel = null,
	readonly = false,
	title = null,
	value = false,
}) => {
	const toggle = () => {
		if (readonly) return;
		if (onChange) onChange({ target: { name, value: !value } });
	};

	const handleClick = event => {
		event.stopPropagation();
		toggle();
	};

	const handleKey = event => {
		if ([13, 32].includes(event.which)) {
			toggle();
			event.preventDefault();
			event.stopPropagation();
		}
	};

	const classNames = ['form-control', 'custom-toggle'];
	if (value) classNames.push('is-toggled');
	if (isInvalid) classNames.push('is-invalid');
	if (isValid) classNames.push('is-valid');
	if (readonly) classNames.push('readonly');

	return <div
			className={classNames.join(' ')}
			role="button"
			aria-pressed={value}
			tabIndex="0"
			title={title}
			onBlur={onBlur ? () => onBlur({ target: { name, value } }) : null}
			onClick={handleClick}
			onKeyDown={handleKey}
		>
			<div className="handle">
				<span className="handle-label">
					{value
						? onLabel || <Icon name="check" />
						: offLabel || <Icon name="times" />
					}
				</span>
			</div>
		</div>;
};

ToggleSwitch.propTypes = {
	isInvalid: PropTypes.bool,
	isValid: PropTypes.bool,
	name: PropTypes.string,
	offLabel: PropTypes.string,
	onBlur: PropTypes.func,
	onChange: PropTypes.func,
	onLabel: PropTypes.string,
	readonly: PropTypes.bool,
	title: PropTypes.string,
	value: PropTypes.bool,
};

export default ToggleSwitch;
